var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-app',{staticClass:"landing",style:({ background: _vm.$vuetify.theme.themes[_vm.theme].landingBackground })},[_c('default-bar'),_c('default-view'),_c('default-footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }